import type { BranchCategory } from '@festina/configuration-general-types/configuration'
import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

export const useBranchCategoryTranslations = (): Record<
  BranchCategory,
  string
> => {
  const translate = useTranslate()

  return useMemo(
    () => ({
      none: translate('branchCategories.none'),
      main: translate('branchCategories.main'),
      feature: translate('branchCategories.feature'),
      release: translate('branchCategories.release'),
    }),
    [translate],
  )
}
